export {Spin as Spinner} from 'antd';
export type {SpinProps} from 'antd/es/spin/index';